import PostRequest from "csi/comm/PostRequest";
import Actions from "csi/def/Actions";
import Request from "csi/def/Request";
import { sessionStore } from "csi/state/rootStore";
import { TableView } from "csi/table/View";
import { QueryLevel } from "csi/view/_query/Level";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import DataSheetTablePreferences from "src/SiteAdmin/DataSheetTablePreferences";
import BOMCustomViewOptionsStore from "src/Specification/BOM/BOMCustomViewOptionsStore";
import BOMOptionsTab from "src/Specification/BOM/BOMOptionsTab";
import BOMSectionMixin from "src/Specification/BOM/BOMSectionMixin";
import DeleteSectionController from "src/Specification/BOM/DeleteSectionController";
import PlacementTable from "src/Specification/BOM/PlacementTable";
import _ from "underscore";


const ACTION_DELETE = "BomSectionDelete";

/**
* Add the "Display Color Images" option to the CV
*/
const _Preferences = declare(DataSheetTablePreferences, {
	constructor() {
		this.addCustomOption("displayColorImages", true, false, "DisplayColorImages");
	},
});

const FoodBOMLineItems = declare([PlacementTable, BOMSectionMixin], {
	allowSuspendInCustomViewPreview: true,
	customViewOptionsComponent: BOMOptionsTab,
	customViewOptionsStore: BOMCustomViewOptionsStore,
	prefClass: _Preferences,

	/** Actions: actions for DSSection groups */
	_bomSectionActions: null,


	/** To support the aggregation view of the Food BOM "New from Material" action: if defined, display only this one section */
	_sectionToDisplay: null,

	// Boolean: override to use expandLevel rather than displayCommentLines
	bSupportsExpandLevelOption: true,

	// Boolean: indicate that widget provides DependencyPath necessary to quickly expand to child BOM items
	bSupportsNonBranchingPathsForExpansion: true,

	/***
	 * @override
	 * C8-35659: When the view is grouped by BOM Section then the group header row has table-row actions "Delete Section"
	 */
	_createQueryLevel(params: object, bRoot: boolean) {
		const ql = this.inherited(arguments) as unknown as QueryLevel;

		if (ql.groupSpec?.heading.m_id == "DSSection") {
			ql.actions = this._bomSectionActions;

			const allSections = this._sectionToDisplay ? [this._sectionToDisplay] : this.getViewNode().AllSections;
			ql.groupDefaultsStore = (this.defView.m_formData) ? null : this._getGroupDefaultsStore(allSections, this.cacheView);
		}

		return ql;
	},

	/**
	 * @override
	 * Inline Delete action of BOM Section
	 */
	_resolveView() {
		const deleteBOMRequest = lang.mixin(new Request(null), {
			m_module: "Specification",
			m_operation: "DeleteBOMSectionDefinitions",
		});

		const tableView = this.defView as TableView;
		if (tableView.shouldAllowActions()) {
			this._bomSectionActions = _.extend(new Actions(), {
				m_actions: [
					this.defView._addViewAction(ACTION_DELETE, {
						classController: DeleteSectionController,
						confirmAction: MessageDialog.BUTTON_DELETE,
						m_accessAction: "_accessActionDeleteSection",
						m_request: deleteBOMRequest,
					}),
				],
			});
		}

		this.inherited(arguments);
	},

	/**
	 * @override
	 * Refresh Total Recipe Quantity first time we enter to the view
	 */
	onViewStart(dfds) {
		if (!this.bViewed && !this.bPopup && !sessionStore.print) {
			const postRequest = new PostRequest("FormulatedProduct", "FoodBOMRefreshRecipeValues")
				.addParameter("ParentUrl", this.urlRoot)
				.post({});
			dfds.push(postRequest);
		}

		this.inherited(arguments);
	},
});

export = FoodBOMLineItems;